// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609231535/js/" + chunkId + "." + {"44":"c1824ffc","225":"038c8a2a","481":"0bab7ae4","486":"6b5e8b17","770":"81317016"}[chunkId] + ".0.6079289164696273.chunk.js";
};